import { createSlice } from "@reduxjs/toolkit";

const seriesSlice = createSlice({

    initialState: [],

    name: "MovieSlice",

    reducers: {
        setsetSeries: (state, action) => {
            // Filter out movies that already exist in the state
            const newMovies = action.payload.filter(
                (movie) => !state.some((m) => m.id === movie.id)
            );
            // Return the new state with the new movies added
            return [...state, ...newMovies];
        },
    }
});

export default seriesSlice.reducer;

export const { setsetSeries } = seriesSlice.actions;